import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SettingsProvider } from "@/context/SettingsContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ChiSono from "@/pages/ChiSono";
import Servizi from "@/pages/Servizi";
import ServizioDetail from "@/pages/ServizioDetail";
import Portfolio from "@/pages/Portfolio";
import Prenota from "@/pages/Prenota";
import BookingManage from "@/pages/BookingManage";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderConfirm from "@/pages/OrderConfirm";
import Library from "@/pages/Library";
import Progetto from "@/pages/Progetto";
import Unsubscribe from "@/pages/Unsubscribe";
import ShopTheProject from "@/pages/ShopTheProject";
import Contatti from "@/pages/Contatti";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import GiftCard from "@/pages/GiftCard";
import AdminLogin from "@/pages/AdminLogin";
import AdminResetPassword from "@/pages/AdminResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import Stima from "@/pages/Stima";
import StimaConferma from "@/pages/StimaConferma";
import Shop from "@/pages/Shop";
import { useSettings } from "@/context/SettingsContext";

function ShopRoute({ detail }) {
  const { settings } = useSettings();
  if (!settings.shop_visible) return <NotFound />;
  return detail ? <ProductDetail /> : <Shop />;
}

function LibraryRoute() {
  const { settings } = useSettings();
  if (settings.library_visible === false) return <NotFound />;
  return <Library />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/chi-sono" element={<ChiSono />} />
                <Route path="/servizi" element={<Servizi />} />
                <Route path="/servizi/:slug" element={<ServizioDetail />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/shop" element={<ShopRoute />} />
                <Route path="/shop/:id" element={<ShopRoute detail />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/ordine/conferma" element={<OrderConfirm />} />
                <Route path="/stima" element={<Stima />} />
                <Route path="/stima-conferma/:token" element={<StimaConferma />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/prenota" element={<Prenota />} />
                <Route path="/prenotazione/gestisci/:token" element={<BookingManage />} />
                <Route path="/contatti" element={<Contatti />} />
                <Route path="/library" element={<LibraryRoute />} />
                <Route path="/progetto/:key" element={<Progetto />} />
                <Route path="/newsletter/disiscrizione" element={<Unsubscribe />} />
                <Route path="/shop-the-project" element={<ShopTheProject />} />
                <Route path="/gift-card" element={<GiftCard />} />
                <Route path="/gift-card/conferma" element={<GiftCard />} />
                <Route path="/privacy" element={<LegalPage slug="privacy" />} />
                <Route path="/cookie" element={<LegalPage slug="cookie" />} />
                <Route path="/termini" element={<LegalPage slug="termini" />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/reset-password" element={<AdminResetPassword />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <Toaster position="top-right" richColors closeButton />
          </BrowserRouter>
        </CartProvider>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
